export const getSumByPropertyName = <T>(items: T[], prop: string) => {
  return items.reduce((a, item) => {
    return a + Number(item[prop as keyof typeof item]);
  }, 0);
};
